import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["qr-field-component-viewer", { 'is-placeholder': !_ctx.qrConfig }]),
    style: _normalizeStyle(_ctx.computedStyle)
  }, _toDisplayString(_ctx.displayText), 7))
}